import React, {
  useState, useEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';

import OvertimeContent from './OvertimeContent';
import OTProfileTab from './OTProfileTab';
import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import SimpleTextInputModal from '../../common/modals/SimpleTextInputModal';
import { getOTProfiles, createOtProfile } from '../state/settings.actions';

const { TabPane } = Tabs;

export default function Overtime({ settings, saveCompanySettings }) {
  const dispatch = useDispatch();
  const profiles = useSelector((state) => state.settings.otProfiles) || [];

  const [activeTab, setActiveTab] = useState('company');
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getOTProfiles());
  }, []);

  const nonCompanyProfiles = profiles.filter((p) => !p.isCompanyProfile);

  const onTabChange = (key) => {
    if (key !== 'add') setActiveTab(key);
  };

  const handleCreate = async (name) => {
    if (!name) {
      setModalOpen(false);
      return;
    }
    const result = await dispatch(createOtProfile({ name, settings: {} }));
    if (result) setModalOpen(false);
  };

  return (
    <div style={{ height: '90vh', width: '100%', overflow: 'hidden' }}>
      <Tabs
        style={{ width: '100%', height: '100%' }}
        tabPosition="left"
        tabBarStyle={{ marginTop: 15, width: 180, overflow: 'auto' }}
        activeKey={activeTab}
        onChange={onTabChange}
      >
        <TabPane tab="Company Default" key="company">
          <div style={{ padding: '10px 20px', overflowY: 'auto', height: 'calc(90vh - 20px)' }}>

            <OvertimeContent
              settings={settings}
              saveCompanySettings={saveCompanySettings}
              showCard
            />
          </div>
        </TabPane>
        {nonCompanyProfiles.map((profile) => (
          <TabPane tab={profile.name} key={profile.id}>
            <OTProfileTab
              profile={profile}
              setActiveTab={setActiveTab}
            />
          </TabPane>
        ))}
        <TabPane
          key="add"
          tab={(
            <OnTraccrButton
              title="Add Profile"
              type="primary"
              onClick={() => setModalOpen(true)}
            />
          )}
        />
      </Tabs>
      <SimpleTextInputModal
        title="Create OT Profile"
        visible={modalOpen}
        placeholder="Enter profile name"
        onClose={() => setModalOpen(false)}
        onSave={handleCreate}
      />
    </div>
  );
}

Overtime.propTypes = {
  settings: PropTypes.shape({}).isRequired,
  saveCompanySettings: PropTypes.func.isRequired,
};
